module.exports = __webpack_public_path__ + "img/SoftwareCopyright_6.8278c240.png";